import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const aiFirstCreateEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-ai-first-create-entrypoint" */ './src/index.tsx'),
	),
	getPreloadProps: () => ({}),
});
